import * as React from 'react';
import { FormControlLabel, Checkbox as Checkbox$1 } from '@mui/material';

var Checkbox = function Checkbox(_ref) {
  var onChange = _ref.onChange,
      checked = _ref.checked,
      disabled = _ref.disabled,
      dataProp = _ref.dataProp,
      descriptionLabel = _ref.descriptionLabel,
      id = _ref.id,
      sx = _ref.sx;
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox$1, {
      inputProps: {
        'aria-label': descriptionLabel
      },
      checked: checked,
      size: "small",
      name: id,
      id: id,
      "data-selector": dataProp,
      disabled: disabled // disableRipple
      ,
      onChange: onChange,
      sx: sx
    }),
    label: id
  });
};

Checkbox.displayName = 'Checkbox';
export { Checkbox };